var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer-bar"},[_c('btn-style',{staticClass:"btn-list-style",attrs:{"btn-list":_vm.btnList}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }